import { Component } from '@angular/core';
import {AttachedFile, BaseState} from "@base/entities/BaseEntities";
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";

class State extends BaseState {
    IsLoadingBarVisible: boolean = false;
}

@Component({
    selector: 'app-demo-components',
    templateUrl: './demo-components.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoComponentsComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService) {
        super(A, 'DemoComponentsComponent', State);
    }

    override OnInitComponent() {
    }
    
    
    public FilesChanged(files: AttachedFile[]) {
        console.log(files);
    }
}
